import type { PatientWorkspace, RailData } from "@bezbolisno/contracts";
import { queryOptions } from "@tanstack/react-query";
import { api, expectOk } from "../../lib/api";
import { keys } from "../../lib/keys";

export const railQuery = queryOptions({
  queryKey: keys.rail,
  queryFn: async (): Promise<RailData> => expectOk(await api.readModels.rail({}), 200),
});

export const workspaceQuery = (patientId: string) =>
  queryOptions({
    queryKey: keys.workspace(patientId),
    queryFn: async (): Promise<PatientWorkspace> =>
      expectOk(await api.readModels.patientWorkspace({ params: { patientId } }), 200),
  });

/** What the old actions revalidated after a patient-side write: the workspace, the rail, the list. */
export const patientKeys = (patientId: string) => [
  keys.workspace(patientId),
  keys.rail,
  keys.patients,
];

export type RailPatient = RailData["patients"][number];
export type Operational = PatientWorkspace["operational"];
export type Clinical = NonNullable<PatientWorkspace["clinical"]>;
export type PatientSnapshot = PatientWorkspace["patient"];
